import request from '../utils/request'

export function getCities() {
    return request({
        url: '/cities',
        method: 'get'
    })
}
